import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  DCRDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayDcrSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.DCR?.submetrics) {
    return <></>;
  }
  if (DCRDataCheck(metrics.DCR?.submetrics!)) {
    return <NoSubMetric />;
  }

  const { giftCardsIssuedCount, oowExceptions } = metrics.DCR?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {giftCardsIssuedCount && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_giftCardsIssued'
                  defaultMessage='Gift Cards issued'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_giftCardsIssued_def'
                defaultMessage={`Resolved contacts for which the associate added a Promo GC (excludes Out of Warranty) or Gift Card to the customer's account.`}
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={giftCardsIssuedCount.datapoint} isBold />
          <DisplaySubMetric
            value={giftCardsIssuedCount.networkAverage}
            datapointNull={giftCardsIssuedCount.datapoint === null}
          />
        </Row>
      )}
      {oowExceptions && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_oopExceptions'
                  defaultMessage='OOP/OOW Exceptions'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_oowExceptions_def'
                defaultMessage='Sum of Resolved contacts for which the associate issued an Out of Warranty promo exception which was later redeemed.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric
            value={Math.round(parseFloat(oowExceptions.datapoint!)).toString()}
            isBold
          />
          <DisplaySubMetric
            value={
              oowExceptions.networkAverage === '--'
                ? '--'
                : Math.round(
                    parseFloat(oowExceptions.networkAverage!)
                  ).toString()
            }
            datapointNull={oowExceptions.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayDcrSubMetrics;
